// The latest roadmap run's state, from the run ledger (roadmap_runs). Every
// press of "Run roadmap now" lands here within a second — queued, in progress,
// published, or failed with where it died — so a run can never vanish silently.

import type { RoadmapRun } from '../../services/roadmapReports';
import { describeRun } from './roadmapRunStatus';
import styles from './RoadmapV2.module.css';

interface Props {
  run: RoadmapRun;
  nowMs: number;
  retrying: boolean;
  /** Omitted for read-only viewers (no admin run power) — hides the retry. */
  onRetry?: () => void;
}

export function RunStatusBanner({ run, nowMs, retrying, onRetry }: Props) {
  const view = describeRun(run, nowMs);
  return (
    <div
      className={`${styles.runBanner} ${styles[`runBanner_${view.tone}`]}`}
      role="status"
      aria-live="polite"
      data-run-state={run.state}
    >
      <div className={styles.runBannerText}>
        <strong>{view.headline}</strong>
        <span>{view.detail}</span>
      </div>
      {view.canRetry && onRetry && (
        <button type="button" className={styles.runBannerRetry} onClick={onRetry} disabled={retrying}>
          {retrying ? 'Queuing…' : 'Run again'}
        </button>
      )}
    </div>
  );
}
